module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_100000_250000.958714e4.png";